import { render } from "./PassContent.vue?vue&type=template&id=764a9068&scoped=true&ts=true"
import script from "./PassContent.vue?vue&type=script&lang=ts"
export * from "./PassContent.vue?vue&type=script&lang=ts"

import "./PassContent.vue?vue&type=style&index=0&id=764a9068&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764a9068"]])

export default __exports__